var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countdown.warning == true)?_c('div',{staticClass:"timer"},[_vm._v(" Your turn ends in "),_c('span',[_vm._v(_vm._s(_vm.msToTime(_vm.countdown.left)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }